import { config } from "config.js";
export interface Constants {
  /** The user's name */
  name: string;
  /** Should the name be rendered in bold */
  priority?: boolean;
}
export interface ColorCodeInterface {
  name: string;
  color: string;
  bgColor: string;
  tagColor: string;
}
export const USER_ROLE_ACCESS = ["NAD Team"];
export const USER_MANAGEMENT_ACCESS = [
  "National Head",
  "NAD Team",
  "Branch EDP",
];
export const BRANCH_HEALTH_ACCESS = [
  "National Head",
  "NAD Team",
  "Regional Head",
  "Academic Head",
];
export const CORPORATE_BRANCH_CODE =
  config["state"] == "PROD" ? 5 : config["state"] == "STAGING" ? 8 : 5;
export const EN_KEY =
  config["state"] == "PROD"
    ? "c0a09148e04f2ac1c4c4b5866bd5e3c0"
    : "385f37178d99309bcd503756daecbd9e";
export const EN_ALGO = "AES-GCM";
export const EN_CLIENT_ID =
  config["state"] == "PROD"
    ? "865218650176-85bncvrkvsn4ug0o8lon67o624lghmo8.apps.googleusercontent.com"
    : "865218650176-ib35ttiarq8imopo3kj8g5ppq7eddco7.apps.googleusercontent.com";
export const EDP_BRANCH_CODE =
  config["state"] == "PROD"
    ? ["1", "2", "4", "7"]
    : config["state"] == "STAGING"
    ? ["5", "6", "8", "11"]
    : ["5", "6", "8", "11"];
export const UPLOAD_ASSET_LASTDATE = "2025-04-14";
export const academicPhase: any = [
  { label: "1", value: "1", key: 1 },
  { label: "2", value: "2", key: 2 },
  { label: "3", value: "3", key: 3 },
  { label: "4", value: "4", key: 4 },
  { label: "5", value: "5", key: 5 },
  { label: "6", value: "6", key: 6 },
  { label: "7", value: "7", key: 7 },
];

export const PtmMode = [
  { label: "In person", value: "In person" },
  { label: "Telephonic", value: "Telephonic" },
  { label: "Online", value: "Online" },
];

export const plannerColumnSortMap: { [key: string]: any } = {
  id: "id",
  sId: "streamId",
  ayId: "acadYearId",
  cId: "classId",
  dtId: "documentTypeId",
  pId: "phaseId",
  sjId: "subjectId",
  uat: "updatedAt",
};

export const filterMap: { [key: string]: any } = {
  streamList: "Stream",
  acadYearList: "Academic year",
  docTypeList: "Document type",
  classList: "Class",
  phaseList: "Phase",
  batchList: "batch",
  subjectList: "Subject",
  roomList: "Room",
  statusList: "Status",
  branch: "Branch",
  startDate: "Start date",
  endDate: "End date",
  ayId: "Academic year",
  bid: "Board",
  cid: "Class",
  lang: "Language",
  sid: "Stream",
  sjId: "Subject",
};
export const filterMapUserManagement: { [key: string]: any } = {
  stream: "Stream",
  subject: "Subject",
  branch: "Branch",
  supervisorEmail: "Supervisor Email",
  fexRole: "Role",
  id: "User Id",
  phone: "Phone No.",
  email: "Email",
  name: "Name",
  status: "Status",
  employeeId: "EmployeeId",
  region: "Region",
};
export const schedulrfilterMap: { [key: string]: any } = {
  subject: "Subject",
  startDate: "Start date",
  endDate: "End date",
};
export const acadYearsData = [
  {
    value: 19,
    key: 19,
    label: 2023,
  },
];
export const Medium = [
  { value: "en", label: "English", key: "en" },
  { value: "hi", label: "Hindi", key: "hi" },
  { value: "hn", label: "Hinglish" },
  { value: "mr", label: "Marathi", key: "mr" },
  { value: "ta", label: "Tamil", key: "ta" },
  { value: "bn", label: "Bangla", key: "bn" },
  { value: "kn", label: "kannada", key: "kn" },
  { value: "gu", label: "Gujrati", key: "gu" },
];
export const Roles = [
  { label: "Super Admin", value: "Super Admin" },
  { label: "Admin", value: "Admin" },
  { label: "Course Admin", value: "Course Admin" },
  { label: "Author", value: "Author" },
  { label: "Proofreader", value: "Proofreader" },
  { label: "Reviewer", value: "Reviewer" },
  { label: "Others", value: "Others" },
];
export const Status = [
  { value: 0, label: "Blocked" },
  { value: 1, label: "Active" },
];

export const AllUserRoles = [
  { label: "National Head", value: "National Head" },
  { label: "NAD Team", value: "NAD Team" },
  { label: "Regional Head", value: "Regional Head" },
  { label: "Academic Head", value: "Academic Head" },
  { label: "EDP Team", value: "Branch EDP" },
  { label: "Academic Counsellor", value: "Academic Counsellor" },
  { label: "Faculty", value: "Faculty" },
];
export const FexRoles = [
  { label: "National Head", value: "National_Head" },
  { label: "NAD Team", value: "NAD_Team" },
  { label: "Regional Head", value: "Regional_Head" },
  { label: "Academic Head", value: "Academic_Head" },
  { label: "EDP Team", value: "Branch_EDP" },
  { label: "Academic Counsellor", value: "Academic_Counsellor" },
  { label: "Faculty", value: "Faculty" },
];
export const NADUserRoles = [
  { label: "NAD Team", value: "NAD Team" },
  { label: "Regional Head", value: "Regional Head" },
  { label: "Academic Head", value: "Academic Head" },
  { label: "EDP Team", value: "Branch EDP" },
  { label: "Academic Counsellor", value: "Academic Counsellor" },
  { label: "Faculty", value: "Faculty" },
];
export const EDPUserRoles = [
  { label: "EDP Team", value: "Branch EDP" },
  { label: "Academic Counsellor", value: "Academic Counsellor" },
  { label: "Faculty", value: "Faculty" },
  { label: "Academic Head", value: "Academic Head" },
];

export const Region = [
  { label: "East", value: "east" },
  { label: "West", value: "west" },
  { label: "North", value: "north" },
  { label: "South", value: "south" },
];
export const EventTypes = [
  {
    label: "ALL",
    value: "ALL",
    key: "ALL",
  },
  {
    label: "LECTURE",
    value: "LECTURE",
    key: "LECTURE",
  },
  {
    label: "DOUBT CLASS",
    value: "DOUBT CLASS",
    key: "DOUBT CLASS",
  },
  {
    label: "EXTRA CLASS",
    value: "EXTRA CLASS",
    key: "EXTRA CLASS",
  },
  {
    label: "DEMO CLASS",
    value: "DEMO CLASS",
    key: "DEMO CLASS",
  },
  {
    label: "PTM",
    value: "PTM",
    key: "PTM",
  },
  {
    label: "ORIENTATION",
    value: "ORIENTATION",
    key: "ORIENTATION",
  },
  {
    label: "HOLIDAY",
    value: "HOLIDAY",
    key: "HOLIDAY",
  },
];
export const RiskColorCode: ColorCodeInterface[] = [
  {
    name: "High",
    color: "#E7685A",
    bgColor: "#FCEEED",
    tagColor: "red",
  },
  {
    name: "Alarming",
    color: "#FD853A",
    bgColor: "#FFF1E5",
    tagColor: "volcano",
  },
  {
    name: "Moderate",
    color: "#FFC247",
    bgColor: "#FFF6E3",
    tagColor: "gold",
  },
  {
    name: "Low",
    color: "#05945B",
    bgColor: "#E6F4ED",
    tagColor: "green",
  },
  {
    name: "NA",
    color: "#757575",
    bgColor: "#F5F5F5",
    tagColor: "",
  },
];
export const Segments = [
  {
    label: "High",
    value: "High",
    key: "High",
  },
  {
    label: "Moderate",
    value: "Moderate",
    key: "Moderate",
  },
  {
    label: "Alarming",
    value: "Alarming",
    key: "Alarming",
  },
];
export const BranchStatus = [
  {
    label: "Active",
    value: 1,
    key: "1",
  },
  {
    label: "Inactive",
    value: "0",
    key: "0",
  },
];
export const LectureStatus = [
  {
    label: "Unmarked",
    value: "Unmarked",
    key: "Unmarked",
  },
  {
    label: "Marked",
    value: "Marked",
    key: "Marked",
  },
];
export const RegionMapping: { [key: string]: any } = {
  NZ: "North",
  SZ: "South",
  FR: "Franchise",
  CZ: "Central",
  WZ: "West",
  "NCR 1": "NCR1",
  EZ: "East",
  NCR: "NCR",
};

export const SegmentMapping: { [key: string]: any } = {
  Moderate: "moderateRisk",
  High: "highRisk",
  Alarming: "alarmingRisk",
  FollowUp: "followUpCount",
};

export const ProgramActionCode: string[] = [
  "APPL",
  "MATR",
  "RADM",
  "FOLO",
  "BTCG",
];
export const GlobalSearchFilterListing: any[] = [
  {
    label: "Student",
    value: "student",
  },
  {
    label: "Faculty",
    value: "faculty",
  },
];

export const GlobalSearchFilterListingWithOutFaculty: any[] = [
  {
    label: "Student",
    value: "student",
  },
];
export const PLAYREADY_LICENCE_PX =
  config["state"] == "PROD" ? "076717" : "843946";
export const WIDEVINE_LICENCE_PX =
  config["state"] == "PROD" ? "0A408C" : "F043C8";
export const Frequency = [
  { label: "Once", value: "ONCE" },
  { label: "Daily", value: "DAILY" },
  { label: "Weekly on a Particular Day", value: "WEEKLY" },
  {
    label: "Monthly on a Particular date",
    value: "MONTHLY",
  },
];
export const CLASS_URL_ENCODE_STRING = "4m3e2r1i@t!";
export const COLORS: any = {
  primary: "#008DC4",
};
export const subjectColorCode: any = {
  Physics: "#FCEEED",
  Chemistry: "#FFF6E3",
  Mathematics: "#E6F9F9",
  Botany: "#E6F4ED",
  Biology: "#E6F4ED",
  Zoology: "#EEF2FE",
  "Social Science": "#FFF6E3",
  "Junior Science": "#FFF6E3",
  MAT: "#E6F9F9",
  "Mental Ability": "#E6F9F9",
  English: "#FFF0F7",
  "General knowledge": "#FCEEED",
  "Political science": "#E6F4ED",
  Economics: "#F0ECFC",
  History: "#FFF1E5",
  "Geography ": "#F0ECFC",
};
export const subjectBorderColorCode: any = {
  Physics: "#E7685A",
  Chemistry: "#FFD47F",
  Mathematics: "#0699A3",
  Botany: "#50B47F",
  Biology: "#50B47F",
  Zoology: "#5384F7",
  "Social Science": "#D29822",
  "Junior Science": "#D29822",
  MAT: "#0699A3",
  "Mental Ability": "#0699A3",
  English: "#D02670",
  "General knowledge": "#B32306",
  "Political science": "#07794C",
  Economics: "#572AC8",
  History: "#FD853A",
  "Geography ": "#572AC8",
};
export const LectureChapterArr: any = [
  {
    label: "Planned Lectures",
    value: "plannedLectures",
  },
  {
    label: "Chapter",
    value: "chapter",
  },
];
export const QuestionType: any = [
  { label: "SCMCQ", value: "SCMCQ" },
  { label: "MCMCQ", value: "MCMCQ" },
  { label: "Assertion Reasoning", value: "ASSR" },
  { label: "Paragraph Based", value: "Scenario" },
  { label: "Question Stem", value: "QSTEM" },
  { label: "Match the List", value: "MATCHLIST" },
  { label: "Matrix Match", value: "MATRIX" },
  { label: "True/ False", value: "TF" },
  { label: "Short Answer Type - Number", value: "SAN" },
  { label: "Short Answer Type - Text", value: "SAT" },
  { label: "Short Answer Type - Date", value: "SAD" },
];
export const QUIZ_TYPE: any = [
  { label: "Multiple Choice", value: "multipleChoice", key: "multipleChoice" },
  { label: "True/False", value: "tf", key: "tf" },
  { label: "Easy", value: "easy", key: "easy" },
];
export const languageArray: any = [
  { value: "en", label: "English" },
  { value: "hi", label: "Hindi" },
  { value: "mr", label: "Marathi" },
  { value: "ta", label: "Tamil" },
  { value: "bn", label: "Bangla" },
  { value: "kn", label: "kannada" },
  { value: "gu", label: "Gujrati" },
];

export const hintAndSolArray: any = [
  { value: 0, label: "Hints" },
  { value: 1, label: "Solutions" },
  { value: 2, label: "Answers" },
  { value: 3, label: "No key" },
];

export const PlusMinus: any = [
  {
    label: "Positive(+)",
    value: "+",
  },
  {
    label: "Negative(-)",
    value: "-",
  },
];
export const sanSub: any = [
  { label: "Single Integer", value: "^d{1}$", regex: "^\\d{1}$" },
  { label: "Double Integer", value: "^d{2}$", regex: "^\\d{2}$" },
  {
    label: "Numeric Value based",
    value: "^d{1,}.d{1,}$",
    regex: "^\\d{1,}\\.\\d{1,}$",
  },
  { label: "Single Decimal", value: "^d.d$", regex: "^\\d{1,5}\\.\\d$" },
  {
    label: "Double Decimal",
    value: "^d{1,2}.d{1,2}$",
    regex: "^\\d{1,5}\\.\\d{2}$",
  },
  { label: "Multi-integer (>2 digits)", value: "^d{1,}$", regex: "^\\d{3,}$" },
  { label: "Numeric Range Integer", value: "^d{1,6},d{1,6}$", regex: "^\\d+$" },
  {
    label: "Numeric Range Single Decimal",
    value: "^d{1,6}.d{1},d{1,6}.d{1}$",
    regex: "^\\d+\\.\\d$",
  },
  {
    label: "Numeric Range Double Decimal",
    value: "^d{1,6}.d{2},d{1,6}.d{2}$",
    regex: "^\\d+\\.\\d{2}$",
  },
];
export const satSub: any = [
  { label: "Long Answer Type Questions", value: "." },
  { label: "Essay Questions", value: ".." },
  { label: "Single word Uppercase", value: "^[A-Z]+$", regex: "^[A-Z]+$" },
  { label: "Single word Lowercase", value: "^[a-z]+$", regex: "^[a-z]+$" },
  { label: "Very Short Answer Type Questions", value: "^.{5}$" },
  { label: "Short Answer Type Questions ", value: "^.{3}$" },
];
export const sadSub: any = [
  {
    label: "Date(dd-mm-yyyy)",
    value: "d{1,2}-d{1,2}-d{4}",
    regex: "^\\d{1,2}-\\d{1,2}-\\d{4}$",
  },
  {
    label: "Time(hh:mm:ss)",
    value: "d{1,2}:d{1,2}:d{2}",
    regex: "^\\d{1,2}:\\d{1,2}:\\d{2}$",
  },
];
export const matrixSub: any = [
  { label: "Column1 x Column2 (4 x 4)", value: "col4-col4" },
  { label: "Column1 x Column2 (4 x 5)", value: "col4-col5" },
];
export const assrSub: any = [
  { label: "Assertion - Reason", value: "assr" },
  { label: "Statement 1 - Statement 2", value: "st1-st2" },
];
export const paragraphSub: any = [
  { label: "Normal Paragraph", value: "paragraph" },
  { label: "Case Study", value: "case-study" },
  { label: "Map/Image based", value: "map-img" },
  { label: "Column-1, 2 , 3 (4 entries each)", value: "col-1-2-3-4each" },
];
export const qstemSub: any = [
  { label: "Normal stem", value: "qstem" },
  { label: "Fill in the blank", value: "fill-blank" },
];
export const matchListSub: any = [
  {
    label: "List-1 (4 entries), List -2 (4 entries)",
    value: "list-1-4ent-list-2-4ent",
  },
  {
    label: "List-1 (4 entries), List -2 (5 entries)",
    value: "list-1-4ent-list-2-5ent",
  },
  {
    label: "List-1 (4 entries), List -2 (6 entries)",
    value: "list-1-4ent-list-2-6ent",
  },
];

export const QuestionTypeWithourPara: any = [
  { label: "--Select--", value: null },
  { label: "SCMCQ", value: "SCMCQ" },
  { label: "MCMCQ", value: "MCMCQ" },
  { label: "Assertion Reasoning", value: "ASSR" },
  { label: "Match the List", value: "MATCHLIST" },
  { label: "Matrix Match", value: "MATRIX" },
  { label: "True/ False", value: "TF" },
  { label: "Short Answer Type - Number", value: "SAN" },
  { label: "Short Answer Type - Text", value: "SAT" },
  { label: "Short Answer Type - Date", value: "SAD" },
];
export const Role: any = [
  { label: "Select...", value: null },
  { label: "Super Admin", value: "Super Admin" },
  { label: "Admin", value: "Admin" },
  { label: "Course Admin", value: "Course Admin" },
  { label: "Author", value: "Author" },
  { label: "Proofreader", value: "Proofreader" },
  { label: "Reviewer", value: "Reviewer" },
  { label: "Others", value: "Others" },
];

export const packageTypeData: any = [
  { label: "Jee Challenger", value: "JeeChallenger" },
  { label: "Neet Challenger", value: "NeetChallenger" },
  { label: "Phoenix", value: "Phoenix" },
  { label: "Neet PG", value: "NeetPg" },
  { label: "Engagement App", value: "Engagement" },
  { label: "All", value: "All" },
];
export const ConceptType: any = [
  { value: "Single", label: "Single" },
  { value: "Multiple", label: "Multiple" },
];
export const LOD2: any = [
  { value: "L1", label: "L1" },
  { value: "L2", label: "L2" },
  { value: "L3", label: "L3" },
  { value: "L4", label: "L4" },
  { value: "L5", label: "L5" },
];
export const BasedOn: any = [
  { value: "Numerical", label: "Numerical" },
  { value: "Conceptual", label: "Conceptual" },
  { value: "Theoretical", label: "Theoretical" },
  { value: "Factual", label: "Factual" },
  { value: "DiagrammaticOrGraphical", label: "Diagrammatic" },
];
export const LOD1: any = [
  { value: "E", label: "Easy", key: "E" },
  { value: "M", label: "Medium", key: "M" },
  { value: "H", label: "Difficult", key: "H" },
];
export const BloomType: any = [
  { value: "Remember", label: "Rote Learning/Remembering" },
  { value: "Understand", label: "Comprehension/Understanding" },
  { value: "Apply", label: "Application" },
  { value: "Analyze", label: "Analysis" },
  { value: "Evaluate", label: "Synthesis/Evaluating" },
  { value: "Create", label: "Create" },
];
export const SubQuestionType: any = [
  { value: null, label: "--Select--" },
  { label: "Single Integer", value: "^d{1}$" },
  { label: "Double Integer", value: "^d{2}$" },
  { label: "Numeric Value based", value: "^d{1,}.d{1,}$" },
  { label: "Single Decimal", value: "^d.d$" },
  { label: "Double Decimal", value: "^d{1,2}.d{1,2}$" },
  { label: "Signed Double Decimal", value: "^[+,-]*d{1,2}.d{1,2}$" },
  { label: "Multi-integer (>2 digits)", value: "^d{1,}$" },
  { label: "Numeric Range Integer", value: "^d{1,6},d{1,6}$" },
  { label: "Numeric Range Single Decimal", value: "^d{1,6}.d{1},d{1,6}.d{1}$" },
  { label: "Numeric Range Double Decimal", value: "^d{1,6}.d{2},d{1,6}.d{2}$" },
  { label: "Long Answer Type Questions", value: "." },
  { label: "Essay Questions", value: ".." },
  { label: "Single word Uppercase", value: "^[A-Z]+$" },
  { label: "Single word Lowercase", value: "^[a-z]+$" },
  { label: "Very Short Answer Type Questions", value: "^.{5}$" },
  { label: "Short Answer Type Questions ", value: "^.{3}$" },
  { label: "Date(dd-mm-yyyy)", value: "d{1,2}-d{1,2}-d{4}" },
  { label: "Time(hh:mm:ss)", value: "d{1,2}:d{1,2}:d{2}" },
];
export const StatusType: any = [
  { value: null, label: "--Select--" },
  { value: "Create", label: "Create" },
  { value: "Draft", label: "Draft" },
  { value: "ProofRead", label: "Proofread" },
  { value: "Review", label: "Review" },
  { value: "Approved", label: "Approved" },
  { value: "Published", label: "Published" },
  { value: "Deactivated", label: "Deactivated" },
];
export const TEST_STATUS: any = [
  { value: "Draft", label: "Draft", key: "Draft" },
  { value: "ProofRead", label: "Proofread", key: "ProofRead" },
  { value: "Review", label: "Review", key: "Review" },
  { value: "Approved", label: "Approved", key: "Approved" },
  { value: "Published", label: "Published", key: "Published" },
];
export const maxLectureMarkAllowedHours = 2;

export const routeToModuleMap: { [key: string]: any } = {
  Login: "Login",
  Dashboard: "Dashboard",
  Performance: "Performance",
  Schedule: "Schedule",
  Planner: "Planner",
  MyLibrary: "My Library",
  FacultyPerformance: "Faculty Performance",
  UserManagement: "User Management",
  Branches: "Faculty Performance",
  Regions: "Faculty Performance",
  Branch: "Faculty Performance",
  Faculties: "Faculty Performance",
  MyBranch: "LOP",
  Batches: "My Batches",
  Mylibrary: "My Library",
  SyllabusCompliances: "Syllabus Compliance",
  Hintsverification: "Hints and Solution Verification",
  " Notifications-service": "Notifications-Service",
};

export const languageMap: any = {
  en: "English",
  hi: "Hindi",
  hn: "Hinglish",
  mr: "Marathi",
  ta: "Tamil",
  bn: "Bangla",
  gu: "Gujrati",
  kn: "kannada",
};
export const returnStatusColor: any = (status = "N/A") => {
  let color = "orange";
  if (status == "Create") {
    color = "purple";
  } else if (status == "Draft") {
    color = "magenta";
  } else if (status == "Proofread") {
    color = "orange";
  } else if (status == "Proofreading") {
    color = "orange";
  } else if (status == "Review") {
    color = "gold";
  } else if (status == "Approved") {
    color = "green";
  } else if (status == "Published") {
    color = "geekblue";
  } else if (status == "Unpublished") {
    color = "red";
  } else if (status == "Deactivated") {
    color = "gray";
  } else if (status == "TBP") {
    color = "volcano";
  } else if (status == "Open") {
    color = "lime";
  } else if (status == "Done") {
    color = "cyan";
  } else if (status == "Recheck") {
    color = "orange";
  } else if (status == "Reassign") {
    color = "blue";
  } else if (status == "N/A") {
    color = "";
  }

  return color;
};
export const EXTRAA_FIELDS = [
  "syllabus",
  "topicName",
  "subTopicName",
  "chapter",
];

export const nodeTypeArray = [
  { label: "--Select--", value: null },
  { label: "CHAPTER", value: "CHAPTER" },
  { label: "TOPIC", value: "TOPIC" },
  { label: "SUB TOPIC", value: "SUB_TOPIC" },
  { label: "SUB SUB TOPIC", value: "SUB_SUB_TOPIC" },
  { label: " SUB SUB SUB TOPIC", value: " SUB_SUB_SUB_TOPIC" },
];
export const myQuestions = [
  { label: "--Select--", value: null },
  { label: "Created", value: "createdByUser" },
  { label: "Assigned", value: "assignedToUser" },
];
export const languageArrayOption = [
  { label: "--Select--", value: null },
  { value: "en", label: "English" },
  { value: "hi", label: "Hindi" },
  { value: "mr", label: "Marathi" },
  { value: "ta", label: "Tamil" },
  { value: "bn", label: "Bangla" },
  { value: "kn", label: "kannada" },
  { value: "gu", label: "Gujrati" },
];
export const DRS_DASHBOARD_ACCESS_ROLE: string[] = [
  "National Head",
  "NAD Team",
  "Regional Head",
  "Academic Head",
];
